var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5862 3.69531L1.48148 15.8009C1.42058 15.862 1.37661 15.9391 1.35567 16.022L0.0139751 21.4072C-0.0261587 21.5694 0.0214784 21.7418 0.139786 21.8601C0.229302 21.9496 0.351274 21.9991 0.476038 21.9991C0.514252 21.9991 0.553339 21.9944 0.591379 21.9848L5.97664 20.643C6.06057 20.622 6.13683 20.5782 6.19773 20.5173L18.3035 8.41261L13.5862 3.69531Z",
    fill: "#32517A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3024 2.04501L19.9549 0.69756C19.0543 -0.203008 17.4848 -0.202136 16.5852 0.69756L14.9347 2.34811L19.6518 7.06523L21.3024 5.41468C21.7522 4.96501 22 4.36649 22 3.72993C22 3.09338 21.7522 2.49486 21.3024 2.04501Z",
    fill: "#32517A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a3ebca092bd28497470e968f1a377114.svg";
export { ForwardRef as ReactComponent };